<template>
  <v-app>
    <v-content>
      <template v-if="loading"></template>
      <template v-else>
        <router-view></router-view>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";
import queryString from "query-string";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    // this.queryinit();
    // this.init();
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
  methods: {
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
    init() {
      var vm = this;
      var liffid = "1654478663-dYb933QK";
      if (true || this.query.apptype == "line") {
        this.initializeLiff(liffid);
      } else {
        window.extAsyncInit = function () {
          // the Messenger Extensions JS SDK is done loading
          vm.loading = false;
        };
      }
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
          vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

#app {
  font-family: "Sarabun", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: #f0ecde !important;
}

.kanit {
  font-family: "Kanit", sans-serif !important;
}

.sarabun {
  font-family: "Sarabun", sans-serif !important;
}

div.error--text {
  color: red !important;
}
</style>

